export default function YouthImpact() {
  const impactOnYouth = [
    { icon: 'ri-user-star-line', title: 'رفع الجاهزية المهنية', description: 'تطوير المهارات والكفاءات المطلوبة في سوق العمل' },
    { icon: 'ri-rocket-line', title: 'تسريع المشاريع', description: 'دعم وتسريع نمو المشاريع الناشئة' },
    { icon: 'ri-team-line', title: 'بناء شبكات علاقات', description: 'ربط الشباب بالخبراء والمستثمرين' },
    { icon: 'ri-briefcase-line', title: 'التوظيف', description: 'فرص عمل مباشرة مع الجهات الراعية' },
    { icon: 'ri-lightbulb-line', title: 'احتضان المواهب', description: 'اكتشاف ورعاية المواهب الواعدة' }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-[#FFF5F3] via-white to-[#FFF5F3] relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-40 left-20 w-80 h-80 bg-[#FF8E53]/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-40 right-20 w-96 h-96 bg-[#FFA07A]/5 rounded-full blur-3xl"></div>
      </div>
      
      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            الأثر على الشباب
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            كيف يستفيد الشباب ورواد الأعمال من المشروع
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8">
          {impactOnYouth.map((impact, index) => (
            <div
              key={index}
              className="group bg-white p-8 rounded-2xl border border-gray-100 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-[#FF8E53] to-[#FFA07A] rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${impact.icon} text-white text-3xl`}></i>
              </div>
              <h4 className="font-bold text-xl text-gray-900 mb-3">
                {impact.title}
              </h4>
              <p className="text-gray-600 leading-relaxed text-sm">
                {impact.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
